import { composeIO } from 'react-compose-io'
import { fieldsTipoLancamentoTransformacaoApiIO } from './FieldsTipoLancamentoTransformacaoApi.IO'
import { FieldsTipoLancamentoTransformacaoApiView } from './FieldsTipoLancamentoTransformacaoApi.View'

export const FieldsTipoLancamentoTransformacaoApi = composeIO(FieldsTipoLancamentoTransformacaoApiView, fieldsTipoLancamentoTransformacaoApiIO)
